import React from "react";

import { BsTelegram, BsTwitter } from 'react-icons/bs';
import { FaWallet, FaHandHoldingUsd } from 'react-icons/fa';
import { AiOutlineSwap } from 'react-icons/ai';
import { BiLineChart, BiChevronDown } from 'react-icons/bi';

const Buystep = () => {
  return (
    <>

      <section className="stepSection padSection text-center">
        <div className="container">
          <div className="stepIn single_cart clearfix">
            <h2>Get started in only 3 steps</h2>
            <div className="row clearfix text-left">
              <div className="col-sm-4">
                <h4><FaWallet /> Create MetaMask Wallet</h4>
                <p>Download & install the MetaMask wallet extension on a desktop browser like Chrome. You can store & manage your TheGrays in this Ethereum wallet.</p>
              </div>
              <div className="col-sm-4">
                <h4><FaHandHoldingUsd /> Buy The Grays</h4>
                <p>You can buy Ether within MetaMask via Uniswap or CoinSwitch by clicking the buy button. You need the ETH to pay transaction fees on Ethereum.</p>
              </div>
              <div className="col-sm-4">
                <h4><AiOutlineSwap /> Swap to ETH</h4>
                <p>Visit TheGrays, connect your MetaMask wallet with the blue button & trade some of your ETH for TheGrays. Leave some ETH in your wallet to cover gas fees.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Buystep;